export default __webpack_public_path__ + "static/media/it.fd758ca8.svg";